import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/wxBill/page', data, {
    trim: true
  })
}

// 手动同步
export function syncWxBill (data) {
  return request.post('/business/wxBill/syncWxBill', data, {
    trim: true
  })
}
